import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, ReplaySubject } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  state = new BehaviorSubject(false);
  private scrollY = new ReplaySubject<boolean>(1);
  private largePackageCounter = 0;
  private largePackageOpened = new ReplaySubject<number>(1);
  public showTableHelper$ = combineLatest([
    this.largePackageOpened.asObservable(),
    this.scrollY.asObservable(),
  ])
    .pipe(
      map(([largePackage, scrolledDown]) => largePackage > 0 && scrolledDown),
      distinctUntilChanged()
    );
  isOpen = false;

  constructor() { }

  toggle(): boolean {
    this.isOpen = !this.isOpen;
    this.state.next(this.isOpen);
    return this.isOpen;
  }

  close() {
    this.isOpen = false;
    this.state.next(false);
  }

  open() {
    this.isOpen = true;
    this.state.next(true);
  }

  setLargePackageOpened(open = false) {
    this.largePackageCounter += open ? 1 : -1;
    this.largePackageOpened.next(this.largePackageCounter);
  }

  setScrollY(y: number) {
    this.scrollY.next(y > 125);
  }

}
